import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import vendorConfig from './config/vendorConfig';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import { Form, Input, FormRow } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var EditVendor = createReactClass({

  getInitialState() {
    return {
      hasBeenFound: false,
    };
  },

  componentWillMount() {
    setViewTitle('Lieferant bearbeiten');
  },

  componentDidMount() {
    request.get({
      url: vendorConfig.apiUrl + this.props.match.params.vendorId,
      success: data => {
        if (this.isMounted()) {
          data.hasBeenFound = true;
          this.setState(data, () => {
            this.form.focusAndSelect('name');
          });
        }
      }
    });
  },

  submitForm(vendor) {
    request.put({
      url: vendorConfig.apiUrl,
      data: vendor,
      success: () => {
        this.props.history.push(`/vendors/${this.state.id}`);
      }
    });
  },

  render() {

    if (!this.state.hasBeenFound) {
      return null;
    }

    return (
      <SimplePage title="Lieferant editieren" icon="paper-plane">
        <Form ref={c => this.form = c}
          onSubmit={this.submitForm}
          isAjaxInProgress={this.props.isAjaxInProgress}
          backButtonLink={`/vendors/${this.state.id}`}>

          <Input name="id" type="hidden" required value={this.state.id} />
          <fieldset>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="name"
                id="name"
                label="Name:"
                type="text"
                required
                value={this.state.name}
              />
            </FormRow>

          </fieldset>
        </Form>
      </SimplePage>
    );

  }

});

export default AjaxInProgressHOC(EditVendor);



// WEBPACK FOOTER //
// ./src/components/vendors/EditVendor.js